import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { QPointProfileComponent } from '../../../projects/qpoint-profile/src/lib/user-profile/user-profile.component';
import { AccordionTestComponent } from '../accordion-test/accordion-test.component';
import {
  ControlGalleryButtonsComponent,
  ControlGalleryDescriptionComponent,
  ControlGalleryDirectivesComponent,
  ControlGalleryDropdownComponent,
  ControlGalleryDropzoneComponent,
  ControlGalleryFormComponent,
  ControlGalleryHeadingComponent,
  ControlGalleryIconsComponent,
  ControlGalleryInputComponent,
  ControlGalleryListComponent,
  ControlGalleryLoadingSpinnerComponent,
  ControlGalleryNotificationsComponent,
  ControlGalleryPdfComponent,
  ControlGalleryPdfPolygonBindingComponent,
  ControlGalleryProgressbarComponent,
  ControlGallerySelectionComponent,
  ControlGalleryTabnavigationComponent,
} from '../control-gallery';
import { ControlGalleryInfoMessageComponent } from '../control-gallery/control-gallery-info-message/control-gallery-info-message.component';
import { ControlGalleryUploadComponent } from '../control-gallery/control-gallery-upload/control-gallery-upload.component';
import {
  ControlGalleryReactiveInputComponent,
} from '../control-gallery/reactive-input/control-gallery-reactive-input.component';
import { ControlGalleryTableRowComponent } from '../control-gallery/table-row/table-row.component';
import { FormValidationDemoComponent } from '../form-validation-demo/form-validation-demo.component';
import { GridTestComponent } from '../grid-test/grid-test.component';
import { LegalComponent } from '../legal/legal.component';
import { MainComponent } from '../main/main.component';
import { MapMultiPolygonTestComponent } from '../map-test/map-multi-polygon/map-multi-polygon.component';
import { MapQSiteProjectTestComponent } from '../map-test/map-qsite-project-test/map-qsite-project-test.component';
import { MapQSiteRoundTripPlanningTestComponent } from '../map-test/map-qsite-roundtripplanning-test/map-qsite-roundtripplanning-test.component';
import { MapSbaProjectTestComponent } from '../map-test/map-sba-project-test/map-sba-project-test.component';
import { MapTbaTestComponent } from '../map-test/map-tba-test/map-tba-test.component';
import { MapTestComponent } from '../map-test/map-test.component';
import { ModalComponent } from '../modal/modal.component';

const routes: Routes = [
  { path: '', redirectTo: '/main', pathMatch: 'full' },
  { path: 'main', loadComponent: () => import('../main/main.component').then(m => m.MainComponent) },
  { path: 'legal', component: LegalComponent },
  { path: 'main/:id', component: MainComponent },
  { path: 'profile', component: QPointProfileComponent },
  { path: 'grid', component: GridTestComponent },
  { path: 'maps', component: MapTestComponent },
  { path: 'map-tba', component: MapTbaTestComponent },
  { path: 'map-sba-project', component: MapSbaProjectTestComponent },
  { path: 'map-qsite-project', component: MapQSiteProjectTestComponent },
  { path: 'map-qsite-roundtripplanning', component: MapQSiteRoundTripPlanningTestComponent },
  { path: 'map-multi-polygon', component: MapMultiPolygonTestComponent },
  { path: 'buttons', component: ControlGalleryButtonsComponent },
  { path: 'directives', component: ControlGalleryDirectivesComponent },
  { path: 'forms', component: ControlGalleryFormComponent },
  { path: 'form-validation', component: FormValidationDemoComponent },
  { path: 'loading-spinners', component: ControlGalleryLoadingSpinnerComponent },
  { path: 'descriptions', component: ControlGalleryDescriptionComponent },
  { path: 'dropdowns', component: ControlGalleryDropdownComponent },
  { path: 'dropzone', component: ControlGalleryDropzoneComponent },
  { path: 'reactiveInput', component: ControlGalleryReactiveInputComponent },
  { path: 'headings', component: ControlGalleryHeadingComponent },
  { path: 'icons', component: ControlGalleryIconsComponent },
  { path: 'inputs', component: ControlGalleryInputComponent },
  { path: 'lists', component: ControlGalleryListComponent },
  { path: 'notifications', component: ControlGalleryNotificationsComponent },
  { path: 'progressbars', component: ControlGalleryProgressbarComponent },
  { path: 'selections', component: ControlGallerySelectionComponent },
  { path: 'tabnavigation', component: ControlGalleryTabnavigationComponent },
  { path: 'tablerows', component: ControlGalleryTableRowComponent },
  { path: 'upload', component: ControlGalleryUploadComponent },
  { path: 'pdf', component: ControlGalleryPdfComponent },
  { path: 'pdf-polygon-binding', component: ControlGalleryPdfPolygonBindingComponent },
  { path: 'info-message', component: ControlGalleryInfoMessageComponent },
  { path: 'lazy-loading', loadChildren: () => import('../modules/lazy-loading/lazy-loading.module').then(m => m.LazyLoadingModule) },
  { path: 'calendar', loadChildren: () => import('../calendar/calendar.module').then(m => m.CalendarModule) },
  { path: 'date-formatting', loadChildren: () => import('../date-formatting/date-formatting.module').then(m => m.DateFormattingModule) },
  { path: 'accordion', component: AccordionTestComponent },
  { path: 'modal', component: ModalComponent },
  { path: 'pdf-drawing', loadComponent: () => import('../pdf-drawing/pdf-drawing.component').then(m => m.PdfDrawingComponent) },
  { path: 'charts', loadChildren: () => import('../charts/charts.routes').then(m => m.chartsRoutes) },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
